import React from 'react';
import { Outlet } from 'react-router';
import Profile from '../components/Profile';
import Sidebar from '../components/Sidebar';
import Support from '../components/Support';
import { AuthContext } from '../context/AuthContext';

const WithSidebar = () => {
  const auth = React.useContext(AuthContext);
  
  return (
    <div className='bodySide'>
      <Sidebar style={{position:'absolute', zIndex:'30'}} /> 
      <div className='sideContent'>
        {auth.authState.impersonation && (
          <div className="impersonationBanner">
            <span>
              Режим просмотра кабинета: {auth.authState.impersonation.subject}
            </span>
            <button type="button" onClick={auth.stopImpersonation}>
              Вернуться в админку
            </button>
          </div>
        )}
        {!auth.isAdmin() && <Support/>}
        <Outlet/>
        <Profile/>
      </div>
    </div>
  );
}

export default WithSidebar
